export function renderTableDefinitionGeneratedValueTemplate({
  variableName,
  tableName,
  fieldDefs,
  publishedField,
  generatedFields,
  sortOrderField,
  indexes
}: {
  variableName: string
  tableName: string
  fieldDefs: string
  publishedField: string
  generatedFields: string
  sortOrderField: string
  indexes: string
}): string {
  return `export const ${variableName} = pgTable(
  '${tableName}',
  {
${fieldDefs}${publishedField}${generatedFields}${sortOrderField}
  }${indexes}
)
`
}
